import { Navigate, RouteObject } from 'react-router-dom';
import { RouteConfig } from '~/routes/routeConfig';
import lazyImport from '~/utils/lazyImport';

const F24Page = lazyImport(() => import('~/views/F24/F24'));
const PayF24Page = lazyImport(() => import('~/views/F24/pay/PayF24Page'));
const UploadF24Page = lazyImport(() => import('~/views/F24/pay/UploadF24Page'));

export const f24Routes: RouteObject[] = [
  {
    index: true,
    element: <F24Page />,
  },
  {
    path: 'pay',
    element: <PayF24Page />,
  },
  {
    path: 'upload',
    element: <UploadF24Page />,
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.F24.buildLink()} replace />,
  },
];
